import { createContext } from "react";

const MemberContext = createContext({
  membersById: {},
});

export default MemberContext;
